import {Address} from "../../address/model/Address";
import {User, UserGender} from "../../users/model/User";
import {Email, Phone} from "../../customers/model/Borrower";
import {LeadInfo} from "../../customers/model/LeadInfo";

export interface Contact {
    id: number;
    address: Address;
    leadInfo: LeadInfo;
    email: Email;
    fullName?: string;
    firstName?: string;
    lastName?: string;
    midName?: string;
    gender?: UserGender;
    dateOfBirth?: Date;
    language?: string;
    primaryPhone: Phone;
    secondaryPhone: Phone;
    employee?: User;

    unsubscribed?: boolean;
    sendGridId?: string;
    subscribedForSendgridNews?: boolean;
    deleted?: boolean;
    type: ContactType;
}

export enum ContactType {
    CUSTOMER = "CUSTOMER",
    LEAD = "LEAD",
    PARTNER = "PARTNER",
    LOAN_OFFICER = "LOAN_OFFICER"
}
